module.exports = __webpack_public_path__ + "static/media/FEST.bed9b4eb.png";